import React, { useState } from 'react';
import request, { BASE_URL_UPLOAD } from '../../api';
import TextEditor from '../Generals/TextEditor';

const WordUploader = ({ data, Url }) => {
    const [value, setValue] = useState("");
    const uploadUrl = Url ? `${BASE_URL_UPLOAD}${Url}` : `/doc/upload`;

    const onUpload = async () => {
        const blob = new Blob([JSON.stringify(value)], {
            type: 'application/text',
        });
        const formData = new FormData();
        formData.append("doc", blob, "fword.txt");
        const { data: axData } = await request.post(uploadUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (data?.setValue)
            data.setValue(axData?.docUrl);
    };

    return (
        <div style={{ height: '40vh' }}>
            <TextEditor docUrl={data?.value} data={{ value, setValue }} onUpload={onUpload} />
        </div>
    );
};



export default WordUploader;